// extracted by mini-css-extract-plugin
export default {"zoomModal":"D1-z","image":"E1-z","button":"F1-z","isOverlayShown":"G1-z"};